module.exports = __webpack_public_path__ + "static/sharing-pc-e2106d6fe8dd268bcd53bb6c71b99403.png";